import React from 'react';
import { ComposedChart, Line, XAxis, Tooltip, ResponsiveContainer } from 'recharts';

import { Box, Typography } from '@mui/material';

const getMonthName = (monthIndex) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return months[monthIndex - 1];
};

const LineChart = ({ firstName, lastName, memberReport }) => {
  let data = [];

  if (memberReport) {
    // Correctly map monthOnMonthAttendance to data
    data = memberReport.memberReport.monthOnMonthAttendance.map((entry) => ({
      name: `${getMonthName(entry.month)} ${entry.year}`, // Get month name and year
      Present: entry.count, // Use count as Present
    }));
    console.log(memberReport);
  } else {
    // Example data for when monthOnMonthAttendance is null
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    data = Array.from({ length: 6 }, (_, i) => {
      const offset = 5 - i;
      const calculatedMonth = currentMonth - offset;
      const month = calculatedMonth <= 0 ? calculatedMonth + 12 : calculatedMonth;
      const year = calculatedMonth <= 0 ? currentYear - 1 : currentYear;

      return {
        name: `${getMonthName(month)} ${year}`,
        Present: 0,
      };
    });
    // console.log('it is fucking null');
  }
  const counts = memberReport.memberReport.monthOnMonthAttendance.map((item) => item.count);
  console.log(counts);

  return (
    <Box height="92%" width={'100%'}>
      <Typography color={'#808191'}>
        Last Six Months Attendance for{' '}
        <b>
          {firstName} {lastName}
        </b>
      </Typography>

      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          width={600}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 80,
            bottom: 20,
            left: 20,
          }}
        >
          <XAxis dataKey="name" label={{ value: '', position: 'insideBottomLeft', offset: 0 }} scale="band" />
          <Tooltip />
          <Line type="monotone" dataKey="Present" className="barChartLine" stroke="#000080" />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default LineChart;
